// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"f23a687d","3351":"4999efc0","5229":"5be31c45","7645":"897d2ef0","9946":"582833bc"}[chunkId] + ".chunk.css";
};